var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLeftArrowColered(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 5,
    height: 8,
    viewBox: "0 0 5 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M1.88875 4L5 0.888749L4.11125 0L0.111251 4L4.11125 8L5 7.11125L1.88875 4Z",
    fill: "#63658E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftArrowColered);
export default __webpack_public_path__ + "static/media/leftArrowColered.5a0cc6512531863b3c1f846b6257ed37.svg";
export { ForwardRef as ReactComponent };